import { render, staticRenderFns } from "./WarningLanguageNotification.vue?vue&type=template&id=79f001f4&scoped=true&"
import script from "./WarningLanguageNotification.vue?vue&type=script&lang=js&"
export * from "./WarningLanguageNotification.vue?vue&type=script&lang=js&"
import style0 from "./WarningLanguageNotification.vue?vue&type=style&index=0&id=79f001f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f001f4",
  null
  
)

export default component.exports